"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertIdsToNames = convertIdsToNames;
exports.convertNamesToIds = convertNamesToIds;
exports.formatParameterValue = formatParameterValue;
exports.parseParameterValue = parseParameterValue;
exports.parseParameters = parseParameters;
exports.readVariableWidthValue = readVariableWidthValue;
exports.writeParameters = writeParameters;
exports.writeVariableWidthValue = writeVariableWidthValue;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * This file contains functions used to read parameters found in watchface bin filess
 */

/**
 * Read binary parameters structure
 * 
 * @param {Uint8Array} byteArray An Uint8Array containing parameters
 * @param {number} valueBitSize Precision of binary encoded values
 * @returns {object} An object containing the data
 */
function parseParameters(byteArray, valueBitSize) {
  var result = {};
  var offset = 0; // Read each key value pair, until the end of array

  do {
    // First value is a descriptor containing key and `hasChildren` flag
    var _readVariableWidthVal = readVariableWidthValue(byteArray.subarray(offset), valueBitSize),
        _readVariableWidthVal2 = _slicedToArray(_readVariableWidthVal, 2),
        fieldDescriptor = _readVariableWidthVal2[0],
        keySize = _readVariableWidthVal2[1];

    var key = fieldDescriptor >> 3;
    var hasChildren = fieldDescriptor & 0x02;

    if (key === 0) {
      throw new Error("Invalid key of 0 found found at offset ".concat(offset));
    }

    offset += keySize; // From the second byte on is the value

    var fieldValue = void 0,
        valueSize = void 0;

    if (fieldDescriptor & 0x05) {
      // float value
      fieldValue = new DataView(byteArray.buffer, byteArray.byteOffset, offset + 4).getFloat32(offset, true);
      valueSize = 4;
    } else {
      // variable width value
      var _readVariableWidthVal3 = readVariableWidthValue(byteArray.subarray(offset), valueBitSize);

      var _readVariableWidthVal4 = _slicedToArray(_readVariableWidthVal3, 2);

      fieldValue = _readVariableWidthVal4[0];
      valueSize = _readVariableWidthVal4[1];
    }

    offset += valueSize;

    if (hasChildren) {
      // When node has children, field value is size of children
      var childrenSize = fieldValue;

      if (childrenSize <= 0) {
        throw new Error("Children size of 0 or less");
      } // Recursive call to read children data


      fieldValue = parseParameters(byteArray.subarray(offset, offset + childrenSize), valueBitSize);
      offset += childrenSize;
    }

    if (key in result) {
      // duplicate key, it's a list
      if (!Array.isArray(result[key])) {
        result[key] = [result[key]];
      }

      result[key].push(fieldValue);
    } else {
      result[key] = fieldValue;
    }
  } while (offset < byteArray.length);

  return result;
}
/**
 * 
 * @param {object} parameters An object with integers as keys and values
 * @param {number} valueBitSize Precision of binary encoded values
 * @returns {Uint8Array} Binary representation
 */


function writeParameters(parameters, valueBitSize) {
  var result = [];

  for (var _i2 = 0, _Object$entries = Object.entries(parameters); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        key = _Object$entries$_i[0],
        valueOrList = _Object$entries$_i[1];

    // In case the value is a list, write multiple values with same key
    var _iterator = _createForOfIteratorHelper(Array.isArray(valueOrList) ? valueOrList : [valueOrList]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;

        // base case
        if (typeof value === "number") {
          // write key
          result.push.apply(result, _toConsumableArray(writeVariableWidthValue(key << 3, valueBitSize))); // write value

          result.push.apply(result, _toConsumableArray(writeVariableWidthValue(value, valueBitSize)));
        } else if (Array.isArray(value) || _typeof(value) === "object") {
          // recursive call for children
          var children = writeParameters(value, valueBitSize); // write key

          result.push.apply(result, _toConsumableArray(writeVariableWidthValue(key << 3 | 0x02, valueBitSize))); // write children size

          result.push.apply(result, _toConsumableArray(writeVariableWidthValue(children.length, valueBitSize))); // write children

          result.push.apply(result, _toConsumableArray(children));
        } else {
          throw Error("Value is invalid");
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return new Uint8Array(result);
}
/**
 * Read variable width value from a byte array
 *
 * For each byte:
 * The msb indicates if this is the last byte (0), or if data continues on the next byte (1).
 * The 7 remaining bits are the actual data (lsb first, little endian style)
 * 
 * The value is interpreted as a signed 64 bit integer
 * Because javascript number type is a 64 bit float, values bigger than 9e15 may not be represented accurately
 * BigInt could be returned, but a value that big is likely never needed
 * @param {Uint8Array} byteArray An Uint8Array containing variable width value
 * @param {number} valueSize Value size in bits, default to 64bits
 * @returns {[number, number]} An Array with :
 *          - the value
 *          - number of bytes read from array (used to encode this value)
 */


function readVariableWidthValue(byteArray) {
  var valueSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
  var value = BigInt(0);

  for (var i = 0; i < 10; i++) {
    // Up to a maximum of 10 bytes (Number of byte needed to represent 64 bit values (10 * 7 > 64)
    var _byte = byteArray[i];
    value |= BigInt(_byte & 0x7f) << BigInt(i * 7);

    if (!(_byte & 0x80)) {
      break; // this is the last chunk of data
    }
  }

  return [Number(BigInt.asIntN(valueSize, value)), i + 1];
}
/**
 * 
 * @param {number} value The value to encode
 * @param {number} valueSize Value size in bits, default to 64bits
 * @returns {Uint8Array} An array containing the encoded value
 */


function writeVariableWidthValue(value) {
  var valueSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
  var result = [];
  var valueBigInt = BigInt.asUintN(valueSize, BigInt(value));

  for (var i = 0; i < 10; i++) {
    // Up to a maximum of 10 bytes (Number of byte needed to represent 64 bit values (10 * 7 > 64)
    // Read lower 7 bits of value
    var _byte2 = Number(valueBigInt & 0x7Fn);

    valueBigInt = valueBigInt >> 7n; // If no data left after this byte, we can stop

    if (!valueBigInt) {
      result.push(_byte2);
      break;
    } // Add byte with flag meaning the data continues in the next byte


    result.push(_byte2 | 0x80);
  }

  return new Uint8Array(result);
}
/**
 * Convert parameters ids to human readable names
 * @param {object} parameters A parameters object containing ids as keys
 * @param {object} fileStructureInfo A file structure descriptor containing the description of the params
 * @returns {object} A copy of the parameters object with ids replaced by names
 */


function convertIdsToNames(parameters, fileStructureInfo) {
  var converter = new ParametersNameConverter(fileStructureInfo);
  return converter.convertIdToName(parameters);
}
/**
 * Convert human readable names to parameters ids
 * @param {object} parameters A parameters object containing names as keys
 * @param {object} fileStructureInfo  A file structure descriptor containing the description of the params
 * @returns {object} A copy of the parameters object with names replaced by ids
 */


function convertNamesToIds(parameters, fileStructureInfo) {
  var converter = new ParametersNameConverter(fileStructureInfo);
  return converter.convertNameToId(parameters);
}

var ParametersNameConverter = /*#__PURE__*/function () {
  function ParametersNameConverter(parametersDescription) {
    _classCallCheck(this, ParametersNameConverter);

    // Convert parameters description and types, to be used while converting ids to name
    this.parametersDescriptionFromId = this.convertParametersDescriptionToIdAsKey(parametersDescription.parameters);
    this.parametersDescriptionFromName = this.convertParametersDescriptionToNameAsKey(parametersDescription.parameters);
    this.parametersTypesDescriptionFromId = {};
    this.parametersTypesDescriptionFromName = {};

    for (var _i3 = 0, _Object$entries2 = Object.entries(parametersDescription.types); _i3 < _Object$entries2.length; _i3++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
          key = _Object$entries2$_i[0],
          value = _Object$entries2$_i[1];

      this.parametersTypesDescriptionFromId[key] = this.convertParametersDescriptionToIdAsKey(value);
      this.parametersTypesDescriptionFromName[key] = this.convertParametersDescriptionToNameAsKey(value);
    }
  } // Convert description "id:name": type to "id": {name: "name", type: type}
  // to be used to convert from id to name


  _createClass(ParametersNameConverter, [{
    key: "convertParametersDescriptionToIdAsKey",
    value: function convertParametersDescriptionToIdAsKey(description) {
      // Base case
      if (_typeof(description) !== "object") {
        return description;
      }

      var result = {};

      for (var _i4 = 0, _Object$entries3 = Object.entries(description); _i4 < _Object$entries3.length; _i4++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i4], 2),
            key = _Object$entries3$_i[0],
            value = _Object$entries3$_i[1];

        if (!key.includes(":")) {
          throw new Error("Parameter description is invalid : ".concat(key));
        }

        var _key$split = key.split(":"),
            _key$split2 = _slicedToArray(_key$split, 2),
            id = _key$split2[0],
            name = _key$split2[1];

        result[id] = {
          name: name,
          type: this.convertParametersDescriptionToIdAsKey(value)
        };
      }

      return result;
    } // Convert description "id:name": type to "name": {id: "id", type: type}
    // to be used to convert from name to id

  }, {
    key: "convertParametersDescriptionToNameAsKey",
    value: function convertParametersDescriptionToNameAsKey(description) {
      // Base case
      if (_typeof(description) !== "object") {
        return description;
      }

      var result = {};

      for (var _i5 = 0, _Object$entries4 = Object.entries(description); _i5 < _Object$entries4.length; _i5++) {
        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i5], 2),
            key = _Object$entries4$_i[0],
            value = _Object$entries4$_i[1];

        if (!key.includes(":")) {
          throw new Error("Parameter description is invalid : ".concat(key));
        }

        var _key$split3 = key.split(":"),
            _key$split4 = _slicedToArray(_key$split3, 2),
            id = _key$split4[0],
            name = _key$split4[1];

        result[name] = {
          id: id,
          type: this.convertParametersDescriptionToNameAsKey(value)
        };
      }

      return result;
    }
    /**
     * Convert parameters ids to human readable names using the provided parameters description
     * @param {object|object[]} parameters A parameters object containing ids as keys, or an Array of parameters object
     * @param {object} parametersDescription Optional, if falsy, will use the root parameters description
     * @returns {object|object[]} A copy of the paramters object with ids replaced by names
     */

  }, {
    key: "convertIdToName",
    value: function convertIdToName(parametersList, parametersDescription) {
      if (!parametersDescription) {
        parametersDescription = this.parametersDescriptionFromId;
      } // Base case


      if (typeof parametersList === "number") {
        if (_typeof(parametersDescription) === "object") {
          console.warn("Expected object, but got literal");
          return parametersList;
        }

        return formatParameterValue(parametersList, parametersDescription);
      }

      if (_typeof(parametersDescription) !== "object") {
        console.warn("Expected literal, but got object");
        return parametersList;
      }

      var result = []; // Pack to list if not a list

      if (!Array.isArray(parametersList)) {
        parametersList = [parametersList];
      }

      var _iterator2 = _createForOfIteratorHelper(parametersList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var parameters = _step2.value;
          var object = {};

          for (var _i6 = 0, _Object$entries5 = Object.entries(parameters); _i6 < _Object$entries5.length; _i6++) {
            var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i6], 2),
                key = _Object$entries5$_i[0],
                value = _Object$entries5$_i[1];

            // Unknown parameter name, leave untouched
            if (!(key in parametersDescription)) {
              console.warn("Unknown parameter: ".concat(key));
              object[key] = value;
              continue;
            }

            var _parametersDescriptio = parametersDescription[key],
                name = _parametersDescriptio.name,
                type = _parametersDescriptio.type; // If a generic type is referenced

            if (_typeof(type) !== "object" && type in this.parametersTypesDescriptionFromId) {
              type = this.parametersTypesDescriptionFromId[type];
            }

            object[name] = this.convertIdToName(value, type);
          }

          result.push(object);
        } // Unpack if only 1 object

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (result.length === 1) {
        result = result[0];
      }

      return result;
    }
    /**
    * Convert parameters human readable names to ids using the provided parameters description
    * @param {object|object[]} parameters A parameters object containing name as keys, or an Array of parameters object
    * @param {object} parametersDescription Optional, if falsy, will use the root parameters description
    * @returns {object|object[]} A copy of the paramters object with name replaced by ids
    */

  }, {
    key: "convertNameToId",
    value: function convertNameToId(parametersList, parametersDescription) {
      if (!parametersDescription) {
        parametersDescription = this.parametersDescriptionFromName;
      } // Base case


      if (_typeof(parametersList) !== "object" && !Array.isArray(parametersList)) {
        return parseParameterValue(parametersList, parametersDescription);
      }

      if (_typeof(parametersDescription) !== "object") {
        console.log(parametersDescription);
        throw new Error("Parameter description does not match parameter");
      }

      var result = []; // Pack to list if not a list

      if (!Array.isArray(parametersList)) {
        parametersList = [parametersList];
      }

      var _iterator3 = _createForOfIteratorHelper(parametersList),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var parameters = _step3.value;
          var object = {};

          for (var _i7 = 0, _Object$entries6 = Object.entries(parameters); _i7 < _Object$entries6.length; _i7++) {
            var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i7], 2),
                key = _Object$entries6$_i[0],
                value = _Object$entries6$_i[1];

            if (!(key in parametersDescription)) {
              if (isNaN(key)) {
                // if key is not in description and is not a number, nothing we can do about it
                throw new Error("Unknown key ".concat(key, ", expected one of the folowing : ").concat(Object.keys(parametersDescription)));
              }

              console.warn("Not converted, already an id: ".concat(key));
              object[key] = value;
              continue;
            }

            var _parametersDescriptio2 = parametersDescription[key],
                id = _parametersDescriptio2.id,
                type = _parametersDescriptio2.type; // If a generic type is referenced

            if (_typeof(type) !== "object" && type in this.parametersTypesDescriptionFromName) {
              type = this.parametersTypesDescriptionFromName[type];
            }

            object[id] = this.convertNameToId(value, type);
          }

          result.push(object);
        } // Unpack if only 1 object

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (result.length === 1) {
        result = result[0];
      }

      return result;
    }
  }]);

  return ParametersNameConverter;
}();

var alignmentValues = [{
  value: 2,
  name: "Left"
}, {
  value: 4,
  name: "Right"
}, {
  value: 8,
  name: "HCenter"
}, {
  value: 16,
  name: "Top"
}, {
  value: 32,
  name: "Bottom"
}, {
  value: 64,
  name: "VCenter"
}, {
  value: 18,
  name: "TopLeft"
}, {
  value: 34,
  name: "BottomLeft"
}, {
  value: 66,
  name: "CenterLeft"
}, {
  value: 20,
  name: "TopRight"
}, {
  value: 36,
  name: "BottomRight"
}, {
  value: 68,
  name: "CenterRight"
}, {
  value: 24,
  name: "TopCenter"
}, {
  value: 40,
  name: "BottomCenter"
}, {
  value: 72,
  name: "Center"
}];
var halignmentValues = [{
  value: 0,
  name: "Left"
}, {
  value: 1,
  name: "Center"
}, {
  value: 2,
  name: "Right"
}];
var linkValues = [{
  value: 16,
  name: "music"
}, {
  value: 10,
  name: "cycle"
}, {
  value: 17,
  name: "countdown"
}, {
  value: 18,
  name: "stopwatch"
}, {
  value: 19,
  name: "pomodoro"
}, {
  value: 5,
  name: "workout"
}, {
  value: 25,
  name: "voice"
}];
var datatypeValues = [{
  value: 1,
  name: "Battery"
}, {
  value: 2,
  name: "Steps"
}, {
  value: 3,
  name: "Calories"
}, {
  value: 4,
  name: "HeartRate"
}, {
  value: 5,
  name: "PAI"
}, {
  value: 6,
  name: "Distance"
}, {
  value: 7,
  name: "Unknown7"
}, {
  value: 8,
  name: "Weather"
}, {
  value: 9,
  name: "UVindex"
}, {
  value: 10,
  name: "AirQuality"
}, {
  value: 11,
  name: "Humidity"
}];
/**
 * Format value based on type
 * @param {number} value A signed integer value
 * @param {string} type A string containing the type name
 * @returns {number|string} the correct representation for the given type
 * @throws Error When type is unknow
 */

function formatParameterValue(value, type) {
  switch (type) {
    case "int":
    case "float":
    case "imgid":
      return value;

    case "bool":
      return !!value;

    case "alignment":
      var alignment = alignmentValues.find(function (e) {
        return e.value === value;
      });
      return alignment ? alignment.name : value;

    case "halignment":
      var halignment = halignmentValues.find(function (e) {
        return e.value === value;
      });
      return halignment != null ? halignment.name : value;

    case "link":
      var link = linkValues.find(function (e) {
        return e.value === value;
      });
      return link ? link.name : value;

    case "datatype":
      var datatype = datatypeValues.find(function (e) {
        return e.value === value;
      });
      return datatype ? datatype.name : value;

    case "color":
      // Convert value to unsigned
      value = new Uint32Array([value])[0];
      return "0x" + value.toString(16).toUpperCase();

    default:
      throw new Error("Unknown type: ".concat(type));
  }
}
/**
 * Parse value base on type
 * @param {number|string} representation A representation of the data type
 * @param {string} type A string containing the type name
 * @returns {number} A signed integer representing the value
 */


function parseParameterValue(representation, type) {
  switch (type) {
    case "int":
    case "float":
    case "imgid":
      return representation;

    case "bool":
      return +representation;

    case "alignment":
      return alignmentValues.find(function (e) {
        return e.name === representation;
      }).value;

    case "halignment":
      return halignmentValues.find(function (e) {
        return e.name === representation;
      }).value;

    case "link":
      return linkValues.find(function (e) {
        return e.name === representation;
      }).value;

    case "datatype":
      return datatypeValues.find(function (e) {
        return e.name === representation;
      }).value;

    case "color":
      return parseInt(representation.match(/0x([\da-f]+)/i)[1], 16);

    default:
      throw new Error("Unknown type: ".concat(type));
  }
}